<div class="footer-holder">&copy; Vambie AB {{ year === 2025 ? '2025' : '2025-' + year }}
</div>